<template>
  <div class="select-wrapper">
    <inline-field-actions :schema="schema"></inline-field-actions>
    <select
      class="form-control"
      v-model="value"
      :disabled="disabled"
      :name="schema.inputName"
      :id="getFieldID(schema)"
      :class="schema.fieldClasses"
      @change="selectItem">
        <option v-if="!selectOptions.hideNoneSelectedText" :disabled="schema.required" :value="null">
          {{ selectOptions.noneSelectedText || "&lt;Nothing selected&gt;" }}
        </option>

        <template v-for="item in items">
          <optgroup v-if="item.group" :label="getGroupName(item)">
              <option v-if="item.ops" v-for="i in item.ops" :value="getItemValue(i)">{{ getItemName(i) }}</option>
          </optgroup>
          <option v-if="!item.group" :value="getItemValue(item)"> {{ getItemName(item) }}</option>
        </template>
    </select>
    <input type="text" class="form__inline-field" :value="getItemInputValue(selectedItem)" v-if="selectedItem && selectedItem.hasInputBox" @change="onInputBoxChanged($event, selectedItem)"></input>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';

export default {
  /* eslint-disable no-throw-literal */
  /* eslint-disable max-len */

  mixins: [abstractField],

  data() {
    return {
      selectedItem: null,
    };
  },

  computed: {
    selectOptions() {
      return this.schema.selectOptions || {};
    },

    items() {
      const values = this.schema.values;
      if (typeof (values) === 'function') {
        return this.groupValues(values.apply(this, [this.model, this.schema]));
      }
      return this.groupValues(values);
    },
  },

  methods: {
    selectItem(event) {
      this.selectedItem = this.items.find(item => item.originalValue === event.target.value);
    },

    formatValueToField(value) {
      if (!value) {
        return null;
      }
      return value;
    },

    groupValues(values) {
      const array = [];
      let arrayElement = {};

      values.forEach((item) => {
        arrayElement = null;

        if (item && item.group) {
          // There is in a group.

          // Find element with this group.
          arrayElement = array.find(i => i.group === item.group);

          if (arrayElement) {
            // There is such a group.

            arrayElement.ops.push({
              id: item.id,
              name: item.name,
            });
          } else {
            // There is not such a group.

            // Initialising.
            arrayElement = {
              group: '',
              ops: [],
            };

            // Set group.
            arrayElement.group = item.group;

            // Set Group element.
            arrayElement.ops.push({
              id: item.id,
              name: item.name,
            });

            // Add array.
            array.push(arrayElement);
          }
        } else {
          // There is not in a group.
          array.push(item);
        }
      });

      // With Groups.
      return array;
    },

    getGroupName(item) {
      if (item && item.group) {
        return item.group;
      }

      throw 'Group name is missing! https://icebob.gitbooks.io/vueformgenerator/content/fields/select.html#select-field-with-object-items';
    },

    getItemValue(item) {
      if (item) {
        if (typeof this.schema.selectOptions !== 'undefined'
            && typeof this.schema.selectOptions.value !== 'undefined') {
          return item[this.schema.selectOptions.value];
        }
        if (item.hasInputBox && item.value !== item.originalValue) {
          return `${item.originalValue}: ${item.value}`;
        }
        // Use 'id' instead of 'value' cause of backward compatibility
        if (typeof item.id !== 'undefined') {
          return item.id;
        }
        throw '`id` is not defined. If you want to use another key name, add a `value` property under `selectOptions` in the schema. https://icebob.gitbooks.io/vueformgenerator/content/fields/select.html#select-field-with-object-items';
      } else {
        return item;
      }
    },

    getItemName(item) {
      if (item) {
        if (typeof this.schema.selectOptions !== 'undefined' && typeof this.schema.selectOptions.name !== 'undefined') {
          return item[this.schema.selectOptions.name];
        }
        if (typeof item.name !== 'undefined') {
          return item.name;
        }
        throw '`name` is not defined. If you want to use another key name, add a `name` property under `selectOptions` in the schema. https://icebob.gitbooks.io/vueformgenerator/content/fields/select.html#select-field-with-object-items';
      } else {
        return item;
      }
    },

    getItemInputValue(item) {
      return item.value !== item.originalValue ? item.value : '';
    },

    onInputBoxChanged(event, item) {
      item.value = event.target.value;
      this.value = this.getItemValue(item);
    },
  },
};
</script>
